import React, { useState, useEffect } from "react";
import { getEmiBreakDownListData, DownloadEmiBreakdownLeadListData, getCollectionBreakDownListData, DownloadCollectionBreakdownLeadListData } from "../API's/Actioncreator";
import Loader from '../../../../presentationals/Loader/Loader.component'


const statusStyle = {
    Active: { background: "#EAF3DE", color: "#3B6D11" },
    Paid: { background: "#EAF3DE", color: "#3B6D11" },
    "On Leave": { background: "#FAEEDA", color: "#854F0B" },
    Remote: { background: "#E6F1FB", color: "#185FA5" },
    Unpaid: { background: "#FAEEDA", color: "#854F0B" },
};

function DownloadIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: 'auto' }}>
            <path d="M8 2v8M5 7l3 3 3-3M3 12h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

const size = 10;
export default function Popup({ onClose, InfoActiveEmi, currentFilterDate,nbfc, emiCardShow }) {
    const [loader, setLoader] = useState(false)
    const [statusFilter, setStatus] = useState("false");
    const [downloaded, setDownloaded] = useState(false);
    const [hovered, setHovered] = useState(null);
    const [currentPage, setCurrentPage] = useState(0)
    const [tableData, settableData] = useState([])
    const [totalPage, setTotalPage] = useState(0)



    function handleDownload() {

        setLoader(true)
        if (emiCardShow == "emi") {
            DownloadEmiBreakdownLeadListData(currentFilterDate?.start, currentFilterDate?.end, InfoActiveEmi?.month,nbfc ?? "", callback => {
                setLoader(false)
            })
        } else {
            DownloadCollectionBreakdownLeadListData(currentFilterDate?.start, currentFilterDate?.end, InfoActiveEmi?.month,nbfc ?? "", callback => {
                setLoader(false)
            })
        }
    }

    /* ── styles ─────────────────────────────────────────────── */
    const s = {
        overlay: {
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "24px",
        },
        popup: {
            background: "#fff",
            borderRadius: "12px",
            border: "0.5px solid #e0e0d8",
            width: "100%",
            maxWidth: "1000px",
            boxSizing: "border-box",
            overflow: "hidden",
            fontFamily: "system-ui, -apple-system, sans-serif",
        },
        header: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 20px",
            borderBottom: "0.5px solid #ebebeb",
        },
        title: {
            margin: 0,
            fontSize: "16px",
            fontWeight: 500,
            color: "#1a1a18",
        },
        subtitle: {
            margin: "2px 0 0",
            fontSize: "13px",
            color: "#888780",
        },
        downloadBtn: {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 14px",
            background: "#fff",
            border: "0.5px solid #d0d0c8",
            borderRadius: "8px",
            fontSize: "13px",
            fontWeight: 500,
            color: downloaded ? "#3B6D11" : "#1a1a18",
            cursor: "pointer",
        },
        filterBar: {
            display: "flex",
            gap: "8px",
            padding: "12px 20px",
            borderBottom: "0.5px solid #ebebeb",
        },
        input: {
            flex: 1,
            padding: "7px 12px",
            fontSize: "13px",
            borderRadius: "8px",
            border: "0.5px solid #d0d0c8",
            background: "#f6f6f3",
            color: "#1a1a18",
            outline: "none",
        },
        select: {
            padding: "7px 10px",
            fontSize: "13px",
            borderRadius: "8px",
            border: "0.5px solid #d0d0c8",
            background: "#fff",
            color: "#1a1a18",
            outline: "none",
        },
        tableWrap: {
            overflowX: "auto",
            scrollbarWidth: "thin",
            padding: "0 20px",
        },
        table: {
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "13px",
        },
        th: {
            textAlign: "left",
            padding: "10px 8px",
            fontWeight: 500,
            color: "#888780",
            whiteSpace: "nowrap",
            borderBottom: "0.5px solid #ebebeb",
        },
        tdBase: {
            padding: "10px 8px",
            whiteSpace: "nowrap",
            borderBottom: "0.5px solid #ebebeb",
        },
        badge: (status) => ({
            ...(statusStyle[status] || { background: "#F1EFE8", color: "#5F5E5A" }),
            padding: "3px 10px",
            borderRadius: "99px",
            fontSize: "12px",
            fontWeight: 500,
        }),
        footer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "12px 20px",
            borderTop: "0.5px solid #ebebeb",
            marginTop: "8px",
        },
        closeBtn: {
            padding: "7px 16px",
            fontSize: "13px",
            borderRadius: "8px",
            border: "0.5px solid #d0d0c8",
            background: "transparent",
            color: "#888780",
            cursor: "pointer",
        },
    };

    useEffect(() => {
        Api(currentPage, statusFilter);
    }, [currentPage, statusFilter]);


    const Api = (page, statusFilter) => {
        setLoader(true)
        if (emiCardShow == "emi") {
            getEmiBreakDownListData(currentFilterDate?.start, currentFilterDate?.end, InfoActiveEmi?.month, statusFilter, page, size,nbfc ?? "", callback => {
                setLoader(false)
                settableData(callback?.data?.records ?? [])
                setTotalPage(callback?.data?.totalElements ?? 0)
            })
        } else {
            getCollectionBreakDownListData(currentFilterDate?.start, currentFilterDate?.end, InfoActiveEmi?.month, statusFilter, page, size,nbfc ?? "", callback => {
                setLoader(false)
                settableData(callback?.data?.records ?? [])
                setTotalPage(callback?.data?.totalElements ?? 0)
            })
        }
    }

    return (
        <div style={s.overlay} onClick={(e) => e.target === e.currentTarget && onClose?.()}>
            <div style={s.popup}>
                {loader ? <Loader /> : ""}

                {/* ── header row ── */}
                <div style={s.header}>
                    <div>
                        <p style={s.title}>{InfoActiveEmi?.month}</p>
                        <p style={s.subtitle}>{InfoActiveEmi?.emi} EMI — {totalPage} records found</p>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <select
                            style={s.select}
                            value={statusFilter}
                            onChange={(e) => {
                                const value = e.target.value;
                                setCurrentPage(0);
                                setStatus(value);
                            }}
                        >
                            {/* <option value={null}>All</option> */}
                            <option value="true">Paid</option>
                            <option value="false">Unpaid</option>

                        </select>
                        <button style={s.downloadBtn} onClick={handleDownload}>
                            <DownloadIcon />
                            {downloaded ? "✓ Downloaded!" : "Download CSV"}
                        </button>
                    </div>
                </div>

                {
                    emiCardShow == "collection" ?
                        <div style={{ borderBottom: '0.5px solid rgb(235, 235, 235)', padding: '5px', display: 'flex', justifyContent: 'space-around' }}>
                            {
                                InfoActiveEmi?.overdueAgingBuckets?.map((val, id) => {
                                    return (
                                        <div style={{ display: 'flex', alignItems: 'center',gap:'5px' }}>
                                            <div style={{
                                                width: '15px', height: '15px', borderRadius: '50%',
                                                backgroundColor: val?.riskLabel == "Low" ? "#1B5E20" : val?.riskLabel == "Medium" ? "#F57F17" : val?.riskLabel == "High" ? "#D84315" : val?.riskLabel == "Critical" ? "#B71C1C" : ""
                                            }}></div>
                                            <h5>{val?.bucketLabel}</h5>
                                            <h5>({val?.overdueCount})</h5>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        : ""}



                {/* ── table ── */}
                <div style={s.tableWrap}>
                    <table style={s.table}>
                        <thead>
                            <tr>
                                {["Name", "Mobile Number", "EMI Date", "Principal", "Interest", "EMI Amount", "EMI Paid Amount", "Paid Date", "Overdue Amount", "Overdue Days", "Status", "Comment", "Comment By"].map((h) => {
                                    if (emiCardShow == "emi" && (h == "Overdue Amount" || h == "Overdue Days")) return null;
                                    return (
                                        <th key={h} style={s.th}>{h}</th>
                                    )
                                })}

                            </tr>
                        </thead>
                        <tbody>
                            {tableData?.length === 0 ? (
                                <tr>
                                    <td colSpan={8} style={{ textAlign: "center", padding: "24px 0", color: "#888780", fontSize: "13px" }}>
                                        No records match your filter.
                                    </td>
                                </tr>
                            ) : (
                                tableData?.map((r, i) => (
                                    <tr
                                        key={i}
                                        style={{ background: hovered === i ? "#f6f6f3" : "transparent", transition: "background 0.1s" }}
                                        onMouseEnter={() => setHovered(i)}
                                        onMouseLeave={() => setHovered(null)}
                                    >
                                        <td style={{ ...s.tdBase, fontWeight: 500, color: "#1a1a18" }}>{r?.userName ?? ""}</td>
                                        <td style={{ ...s.tdBase, color: "#888780" }}>{r?.mobileNumber ?? ""}</td>
                                        <td style={{ ...s.tdBase, color: "#888780" }}>
                                            {emiCardShow == "emi" ? r?.emiDate ?? "" : r?.dueDate ?? ""}
                                        </td>
                                        <td style={{ ...s.tdBase, color: "#888780" }}>{r?.principal ?? ""}</td>
                                        <td style={{ ...s.tdBase, color: "#888780" }}>{r?.interest ?? ""}</td>
                                        <td style={{ ...s.tdBase, color: "#888780" }}>{r?.emiAmount ?? ""}</td>
                                        <td style={{ ...s.tdBase, color: "#888780" }}>{r?.emiPaidAmount ?? ""}</td>
                                        <td style={{ ...s.tdBase, color: "#888780" }}>{r?.paidDate ?? ""}</td>
                                        {
                                            emiCardShow == "collection" ?
                                                <>
                                                    <td style={{ ...s.tdBase, color: "#888780" }}>{r?.overdueAmount ?? ""}</td>
                                                    <td style={{ ...s.tdBase, color: "#888780" }}>{r?.overdueDays ?? ""}</td>
                                                </>
                                                : ""}

                                        <td style={s.tdBase}>
                                            <span style={s.badge(r?.statusLabel)}>{r?.statusLabel?.toUpperCase()}</span>
                                        </td>
                                        <td style={{ ...s.tdBase, color: "#888780" }}>{r?.rcComment ?? ""}</td>
                                        <td style={{ ...s.tdBase, color: "#888780" }}>{r?.rcCommentBy ?? ""}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* ── footer ── */}
                <div style={s.footer}>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <button
                            disabled={currentPage === 0}
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                            style={{
                                padding: "6px 10px",
                                borderRadius: "6px",
                                border: "0.5px solid #d0d0c8",
                                background: currentPage === 0 ? "#f0f0f0" : "#fff",
                                cursor: currentPage === 0 ? "not-allowed" : "pointer",
                            }}
                        >
                            Prev
                        </button>

                        {Array.from({ length: Math.ceil(totalPage / size) }, (_, i) => i) // 0-indexed pages
                            .slice(Math.max(0, currentPage - 2), currentPage + 3)
                            .map((page) => (
                                <button
                                    key={page}
                                    onClick={() => setCurrentPage(page)}
                                    style={{
                                        padding: "6px 10px",
                                        borderRadius: "6px",
                                        border: "0.5px solid #d0d0c8",
                                        background: currentPage === page ? "#1a1a18" : "#fff",
                                        color: currentPage === page ? "#fff" : "#000",
                                        cursor: "pointer",
                                    }}
                                >
                                    {page + 1}  {/* Display as 1-indexed */}
                                </button>
                            ))}
                        <button

                            disabled={currentPage >= Math.ceil(totalPage / size) - 1}
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                            style={{
                                padding: "6px 10px",
                                borderRadius: "6px",
                                border: "0.5px solid #d0d0c8",
                                background: currentPage >= Math.ceil((totalPage - 1) / size) ? "#f0f0f0" : "#fff",
                                cursor: currentPage >= Math.ceil((totalPage - 1) / size) ? "not-allowed" : "pointer",
                            }}
                        >
                            Next
                        </button>
                    </div>
                    {/* <span style={{ fontSize: "12px", color: "#888780" }}>
                        {tableData?.length} record{tableData?.length !== 1 ? "s" : ""}
                    </span> */}
                    <button style={s.closeBtn} onClick={onClose}>Close</button>
                </div>

            </div>
        </div>
    );
}
